import { WorkflowService } from 'src/app/services';
import { DataEntity } from './data-entity';
import { ValidatorFn } from '@angular/forms';
import { Contractor } from '../contractor';

export class SelectContractorData {
  selectedRegistrationId: string;
  selectedContractorId: string;
  notInList: boolean;
  selectedContractorBusinessName: string;

  constructor(options?: Partial<SelectContractorData>) {
    if (options) {
      Object.assign(this, options);
    }
  }

  reset() {
    this.selectedContractorBusinessName = null;
    this.selectedContractorId = null;
    this.selectedRegistrationId = null;
    this.notInList = false;
  }
}

export class SelectContractorDataEntity extends DataEntity {
  dataEntityTypeCode: string =
    WorkflowService.DATA_ENTITIES.SelectContractor.code;
  contractorTypeIds: string[] = [];
  allowNotListedOption: boolean;
  allowRegisterRenewOption: boolean = true;
  canEditContractor: boolean = true;
  contractor?: Contractor;
  showLabel?: boolean = true;
  availableRegistrations?: any[];
  inputData: SelectContractorData;
  contractorTypeDetails: {
    [key: string]: {
      id: string;
      name: string;
      registerWorkflowId: string;
      renwalWorkflowId: string;
    };
  };
  updatingRequirements: boolean = false;
  savingRequirements: boolean = false;

  getValidators(): ValidatorFn[] {
    const validators = super.getValidators() || [];

    return validators;
  }

  constructor(options?: Partial<SelectContractorDataEntity>) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }

    if (options?.inputData) {
      this.inputData = new SelectContractorData(options?.inputData);
    } else {
      this.inputData = new SelectContractorData();
    }
  }

  override prepareForSave(): void {
    super.prepareForSave();
    this.contractorTypeDetails = null;
  }
}
